import { InjectionToken } from '@angular/core';
export const OPTIONS_GROUPED_BY_HOST = /*#__PURE__*/new InjectionToken('input-options-grouped-by-host');